/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_CreatedInputs */

const en_settings_apikeys_created = /** @type {(inputs: Settings_Apikeys_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key created`)
};

/**
* | output |
* | --- |
* | "API key created" |
*
* @param {Settings_Apikeys_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created = /** @type {((inputs?: Settings_Apikeys_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_created(inputs)
});
export { settings_apikeys_created as "settings.apikeys.created" }